import {action, observable} from 'mobx';
import agent from '../agent';

class DiagnosisStore {
    @observable questionList = [];
    @observable category = 'diagnosis1';
    @observable etcDescriptionList = [{
        answerId:43,
        description: '',
    }, {
        answerId:69,
        description: '',
    }];
    @observable answerList = {
        channel: "F",
        privateAgree: true,
        privacyAgree: true,
        diagnosis_question: []
    }

    @action setCategory(category) {
        this.category = category;
    }

    @action setQuestionList(list) {
        this.questionList = list;
    }

    @action setEtcDescription1(value) {
        this.etcDescriptionList[0].description = value;
    }

    @action setEtcDescription2(value) {
        this.etcDescriptionList[1].description = value;
    }

    @action setPrivateAgree(agree) {
        this.answerList.privateAgree = agree;
    }

    @action setPrivacyAgree(agree) {
        this.answerList.privacyAgree = agree;
    }

    @action setFunnels(url) {
        this.answerList.funnels = url;
    }

    @action setDiagnosisQuestion(lists) {
        this.answerList.diagnosis_question = lists;
    }

    getQuestionList(category) {
        return agent.Diagnosis.getQuestionList(category);
    }

    createAnswer(answerList) {
        return agent.Diagnosis.createAnswer(answerList);
    }
}

export default new DiagnosisStore();
